/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { PREFIX } from '../constants';
import * as ACTIONS from '../constants/actions';
import {
    asyncDefaults,
    makeAsyncReducer,
    makeAsyncResetReducer,
    mergeReducers,
} from '../utils/async_utils';
import { RootState } from '../../dev/store';

const addReservation = makeAsyncReducer(ACTIONS.ADD_RESERVATION);
const fetchReservation = makeAsyncReducer(ACTIONS.FETCH_RESERVATION);
const updateReservation = makeAsyncReducer(ACTIONS.UPDATE_RESERVATION);
const resetReservation = makeAsyncResetReducer(ACTIONS.RESET_RESERVATION, {});

const reservation = mergeReducers(
    asyncDefaults({}),
    PREFIX,
    addReservation,
    fetchReservation,
    updateReservation,
    resetReservation
);

export default reservation;

export const selectors = {
    getReservation: (state: RootState) => state.treePermit?.reservation?.data,
};
